// Every write to a policy goes through the backend door, never straight to
// Hasura: a policy obeys canEditRole of the circle carrying it (GOUV-14), a
// rule no row filter can express. public_decision.yaml stops allowing direct
// writes, which is what makes this the only way in.
import { useOrgContext } from '@/org/contexts/OrgContext'
import { Visibility_Enum } from '@gql'
import { useCallback } from 'react'
import { trpc } from 'src/trpc'

export interface DecisionValues {
  title?: string
  description?: string
  visibility?: Visibility_Enum
  circleId?: string
  archivedAt?: string | null
}

export default function useWriteDecision() {
  // The org comes from the context, never from an entity handed in by the
  // caller: a fragment may not carry it (the lesson of 08/08/2026 on roles).
  const { orgId } = useOrgContext()

  return useCallback(
    async (values: DecisionValues, decisionId?: string): Promise<string> => {
      if (!orgId) throw new Error('No org')
      return trpc.decision.write.mutate({
        orgId,
        decisionId: decisionId ?? null,
        values,
      })
    },
    [orgId]
  )
}
